import { put, takeLatest } from "redux-saga/effects";
import axiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectnumber_of_options_of_portfolio_instruments: "[selectnumber_of_options_of_portfolio_instruments] Action",
  selectnumber_of_options_of_portfolio_instrumentsLoading: "[selectnumber_of_options_of_portfolio_instrumentsLoading] Action",
  selectnumber_of_options_of_portfolio_instrumentsAsync: "[selectnumber_of_options_of_portfolio_instrumentsync] Action"
};

const initialState = {
  data: [],
  size: 10,
  total: 0,
  loading: false
};

export const number_of_options_of_portfolio_instruments_select_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectnumber_of_options_of_portfolio_instruments:
      return {
        ...state,
        data: payload,
        total:Object?.keys(payload)?.length
          ? Object?.keys(payload)?.length > 10000
            ? 10000
            : payload.total
          : 0
      };
    case actionTypes.selectnumber_of_options_of_portfolio_instrumentsLoading:
      return {
        ...state,
        loading: payload
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.selectnumber_of_options_of_portfolio_instrumentsLoading, payload: true });

  let config = {
    url: "select_request"
  };

  let data = {
    table: "portfolio",
    method_type: "number_of_options_of_portfolio_instruments",
    data: payload.data ? payload.data : {},
    from: payload.from ? (payload.from - 1) * payload.size : 0,
    size: payload.size,
    sort_by: payload.sort_by
  };

  try {
    let res = yield axiosCustom(config, data);

    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) return;

    yield put({
      type: actionTypes.selectnumber_of_options_of_portfolio_instruments,
      payload: res.data.response.data
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({ type: actionTypes.selectnumber_of_options_of_portfolio_instrumentsLoading, payload: false });
  }
}

export function* number_of_options_of_portfolio_instrumentsSelect() {
  yield takeLatest(actionTypes.selectnumber_of_options_of_portfolio_instrumentsAsync, handleWorker);
}
